import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DATE_RANGE } from '../../utils/constants';
import { rejectWithApiError } from '../../utils/api';
import { RootReducerState } from '../../redux/Reducers';
import { formatDate } from '../../utils/dateUtils';

export const getSalesReportsData = createAsyncThunk<
  Array<{
    date: string;
    serviceTypeId: number;
    orgId: number;
    activatedCount: number;
    disconnectedCount: number;
  }>,
  {
    data: {
      organizations: Array<number>;
      allSubOrgs: boolean;
      allResellers: boolean;
      allServices: boolean;
      serviceTypes: Array<number>;
      type: DATE_RANGE;
      date?: string;
      startDate?: string;
      endDate?: string;
    };
  },
  { state: RootReducerState }
>('salesReports/getSalesReportsData', async ({ data }, thunkAPI) => {
  try {
    if (!data.endDate) {
      delete data.endDate;
    } else {
      data.endDate = formatDate(data.endDate, 'yyyy-MM-dd');
    }

    if (!data.startDate) {
      delete data.startDate;
    } else {
      data.startDate = formatDate(data.startDate, 'yyyy-MM-dd');
    }

    if (!data.date) {
      delete data.date;
    } else {
      data.date = formatDate(data.date, 'yyyy-MM-dd');
    }

    const queryString = Object.keys(data)
      .map(key => key + '=' + data[key])
      .join('&');

    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/sales-reports${queryString ? `?${queryString}` : ''}`
    );
    return response.data;
  } catch (error) {
    return rejectWithApiError({ thunkAPI, error, fallback: 'Error during fetching sales report!' });
  }
});
